import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { FOOD_PARTNERS_PATH } from '../../core/constants';

export const createContactPersonAction = createAsyncThunk(
    'foodPartner/createContactPersonAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(`${ FOOD_PARTNERS_PATH }/${ data.foodPartnerId }/contact-persons`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createContactPersonSlice = createSlice({
    name: 'createContactPersonSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createContactPersonAction.pending, () => STATE__API__STARTED);
        builder.addCase(createContactPersonAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createContactPersonAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createContactPersonState = (state) => state.foodPartner.createContactPerson;
export default createContactPersonSlice.reducer;
